module.exports = __webpack_public_path__ + "static/media/elkhorn_trophy_slough.09ef3a41.jpg";